"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _models = require("@seedlang/models");
var _mobx = require("mobx");
var _root_store = _interopRequireDefault(require("./root_store"));
var _class;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ConceptRootWordStore = (_class = /*#__PURE__*/function (_RootStore) {
  function ConceptRootWordStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, ConceptRootWordStore);
    _this = _callSuper(this, ConceptRootWordStore);
    _this.config = {
      deserialize: true,
      model: _models.Word,
      GET: {
        index: '/concepts/:conceptId/words?sort=target_text&filters[root]=true'
      },
      POST: {
        create: '/concept_words'
      },
      DELETE: {
        destroy: '/concept_words?concept_id=:concept_id&word_id=:word_id'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(ConceptRootWordStore, _RootStore);
  return (0, _createClass2["default"])(ConceptRootWordStore, [{
    key: "allForSelect",
    get: function get() {
      return this.indexData.map(function (item) {
        return {
          id: item.id,
          name: item.targetWithWordTypeParentAndSource
        };
      });
    }
  }, {
    key: "allIds",
    get: function get() {
      return this.indexData.map(function (item) {
        return item.id;
      });
    }
  }]);
}(_root_store["default"]), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "allForSelect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allForSelect"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "allIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allIds"), _class.prototype), _class);
var _default = exports["default"] = new ConceptRootWordStore();